module.exports = __webpack_public_path__ + "img/icon2.72e2d5cf.png";